// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kHpla","footerText":"Footer_footerText__Sk6wf","companyName":"Footer_companyName__F6RCT"};